import { render, staticRenderFns } from "./JBProposalBurglarAlarms.vue?vue&type=template&id=56e93b3d"
import script from "./JBProposalBurglarAlarms.vue?vue&type=script&lang=js"
export * from "./JBProposalBurglarAlarms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports